/* Tusq · In-App Browser Banner (CL-04 / CL-19)
 * Detects FB / IG / TikTok in-app webviews and offers an
 * "Open in default browser" CTA. Dismissable per-session.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'tusq_inapp_banner_dismissed';
  var ua = (navigator.userAgent || navigator.vendor || window.opera || '').toString();

  // UA fingerprints for the major in-app webviews
  var isFacebook  = /FB_IAB|FBAN|FBAV|FB4A|FBIOS/i.test(ua);
  var isInstagram = /Instagram/i.test(ua);
  var isTikTok    = /BytedanceWebview|musical_ly|TikTok/i.test(ua);
  var isPinterest = /Pinterest/i.test(ua);
  var isLinkedIn  = /LinkedInApp/i.test(ua);
  var inAppWebview = isFacebook || isInstagram || isTikTok || isPinterest || isLinkedIn;

  if (!inAppWebview) return;

  // Honor per-session dismiss
  try {
    if (sessionStorage.getItem(STORAGE_KEY) === '1') return;
  } catch (e) { /* private browsing — ignore */ }

  function isIOS()      { return /iPad|iPhone|iPod/.test(ua) && !window.MSStream; }
  function isAndroid()  { return /Android/i.test(ua); }

  function showBanner() {
    var el = document.getElementById('tusq-inapp-banner');
    if (!el) return;
    el.hidden = false;

    // dataLayer event for analytics
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'tusq_inapp_banner_shown',
        client_id_source: isFacebook ? 'facebook' : isInstagram ? 'instagram' : isTikTok ? 'tiktok' : 'other'
      });
    } catch (e) {}

    el.querySelector('[data-tusq-inapp-dismiss]').addEventListener('click', function () {
      el.hidden = true;
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
      try {
        window.dataLayer.push({ event: 'tusq_inapp_banner_dismissed' });
      } catch (e) {}
    });

    el.querySelector('[data-tusq-inapp-open]').addEventListener('click', function () {
      var url = window.location.href;

      try {
        window.dataLayer.push({ event: 'tusq_inapp_banner_open_clicked' });
      } catch (e) {}

      if (isAndroid()) {
        // intent:// URI — opens Chrome by default on Android, falls through cleanly on others
        var clean = url.replace(/^https?:\/\//, '');
        var intent = 'intent://' + clean + '#Intent;scheme=https;package=com.android.chrome;end';
        window.location.href = intent;
        return;
      }

      if (isIOS()) {
        // x-safari-https:// — direct Safari open scheme (works in many iOS webviews)
        var safariUrl = url.replace(/^https:/, 'x-safari-https:');
        window.location.href = safariUrl;

        // Fallback: copy URL after a tick so user can paste in Safari manually
        setTimeout(function () {
          copyToClipboard(url);
          alert('We tried to open Safari. If it didn’t open automatically, the link has been copied — paste it into Safari.');
        }, 800);
        return;
      }

      // Other: just copy
      copyToClipboard(url);
      alert('Link copied — paste it in your default browser.');
    });
  }

  function copyToClipboard(text) {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text);
        return;
      }
    } catch (e) {}
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showBanner);
  } else {
    showBanner();
  }
})();
